import React, { createContext, useContext, useState, useEffect, useRef } from 'react';

const API_URL = process.env.NODE_ENV === 'production'
  ? 'https://ferl.fyi/api'
  : 'http://localhost:3001/api';

export const PlayerContext = createContext(null);

export function PlayerProvider({ children }) {
  const [tracks, setTracks] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [shuffleOn, setShuffleOn] = useState(false);
  const togglePlayPauseRef = useRef(null);

  const fetchTracks = async () => {
    try {
      const res = await fetch(`${API_URL}/tracks`);
      const data = await res.json();
      setTracks(Array.isArray(data) ? data : []);
    } catch {}
  };

  useEffect(() => {
    fetchTracks();
    window.addEventListener('tracksUpdated', fetchTracks);
    return () => window.removeEventListener('tracksUpdated', fetchTracks);
  }, []);

  const playTrack = (index) => {
    setCurrentIndex(index);
    setIsPlaying(true);
  };

  const togglePlayPause = () => {
    if (togglePlayPauseRef.current) togglePlayPauseRef.current();
  };

  return (
    <PlayerContext.Provider value={{
      tracks,
      currentIndex, setCurrentIndex,
      isPlaying, setIsPlaying,
      shuffleOn, setShuffleOn,
      playTrack, togglePlayPause,
      togglePlayPauseRef,
      refetchTracks: fetchTracks,
    }}>
      {children}
    </PlayerContext.Provider>
  );
}

export const usePlayer = () => useContext(PlayerContext);
